import { render } from "./ReportInfo.vue?vue&type=template&id=5296e2a8&scoped=true"
import script from "./ReportInfo.vue?vue&type=script&lang=js"
export * from "./ReportInfo.vue?vue&type=script&lang=js"

import "./ReportInfo.vue?vue&type=style&index=0&id=5296e2a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5296e2a8"]])

export default __exports__